import { render, staticRenderFns } from "./AssignedBrandBotTag.vue?vue&type=template&id=3b585d92&scoped=true&"
import script from "./AssignedBrandBotTag.vue?vue&type=script&lang=js&"
export * from "./AssignedBrandBotTag.vue?vue&type=script&lang=js&"
import style0 from "./AssignedBrandBotTag.vue?vue&type=style&index=0&id=3b585d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b585d92",
  null
  
)

export default component.exports